var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-Box",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.033 12l4.548-4.549c.559-.558.559-1.463 0-2.021l-1.01-1.011c-.559-.559-1.464-.559-2.022 0L12 8.967 7.451 4.42c-.558-.559-1.463-.559-2.021 0l-1.011 1.01c-.559.559-.559 1.464 0 2.022L8.967 12 4.42 16.549c-.559.558-.559 1.463 0 2.021l1.01 1.011c.559.559 1.464.559 2.022 0L12 15.033l4.549 4.548c.558.559 1.463.559 2.021 0l1.011-1.01c.559-.559.559-1.464 0-2.022L15.033 12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTag);
export default __webpack_public_path__ + "static/media/closeTag.15fcee610c2ba472a7dbcac20bac38d1.svg";
export { ForwardRef as ReactComponent };